// extracted by mini-css-extract-plugin
export default {"group":"Projection_group__wkliz","group1":"Projection_group1__hrI4M","cover":"Projection_cover__6u0XD","main":"Projection_main__qnyVk"};